import React from "react";
import Leads from "./Leads";

export default function Opportunities() {
  return <Leads opportunityMode />;
}
